import { Box, CircularProgress, Grid2 as Grid, Typography } from '@mui/material'
import { useAtomValue } from 'jotai'
import * as React from 'react'
import { useNavigate } from 'react-router'

import GroupSessionCard from '../components/cards/GroupSessionCard'
import EmptyStateCard from '../components/common/EmptyStateCard'
import SEOHead from '../components/common/SEOHead'
import { isAdminAtom } from '../domains/auth/AuthSelectors'
import { isInstructorAtom } from '../domains/auth/AuthSelectors'
import GroupSessionService from '../services/GroupSessionService'

export default function GroupSessions() {
  const navigate = useNavigate()
  const isAdmin = useAtomValue(isAdminAtom)
  const isInstructor = useAtomValue(isInstructorAtom)

  const [sessions, setSessions] = React.useState([])
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState(null)

  React.useEffect(() => {
    const fetchSessions = async () => {
      try {
        setLoading(true)
        // TODO: I don't need to filter by status here but I need to add filter later
        const data = await GroupSessionService.getGroupSessions({
          // status: [STATUS.AVAILABLE, STATUS.BOOKED].join(','),
          // size: 2,
        })
        setSessions(data)
      } catch (err) {
        console.error('Failed to fetch group sessions:', err)
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }

    fetchSessions()
  }, [])

  const changeHook = async () => {
    const updatedSessions = await GroupSessionService.getGroupSessions({})
    setSessions(updatedSessions)
  }

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress />
      </Box>
    )
  }

  if (error) {
    return (
      <Box sx={{ p: 2, maxWidth: 1200, mx: 'auto' }}>
        <Typography color="error" variant="h6">
          {error}
        </Typography>
      </Box>
    )
  }

  return (
    <>
      <SEOHead pageName="GROUP_SESSIONS" url="https://bookingonsnow.com/events/sessions" />
      <Box sx={{ p: 2, maxWidth: 1200, mx: 'auto', width: '100%' }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          Group Sessions
        </Typography>

        {sessions.length > 0 ? (
          <Grid container spacing={3} justifyContent="center" alignItems="top" sx={{ width: '100%' }}>
            {sessions.map((session) => {
              return (
                <Grid size={{ xs: 12, sm: 6, md: 4 }} key={session.resourceId}>
                  <GroupSessionCard session={session} mode="card" updateHook={changeHook} deleteHook={changeHook} />
                </Grid>
              )
            })}
          </Grid>
        ) : (
          <EmptyStateCard
            title="No Group Sessions Available Right Now"
            subtitle={
              isInstructor
                ? 'Currently there are no active sessions. Share your expertise by creating a new session - help others discover the joy of winter sports!'
                : "We don't have any sessions scheduled at the moment. Our instructors are preparing new classes - check back soon for exciting learning opportunities!"
            }
            buttonText="Create New Group Session"
            onButtonClick={() => navigate('/group-session/create')}
            showButton={isInstructor || isAdmin}
            image="https://images.pexels.com/photos/848612/pexels-photo-848612.jpeg"
          />
        )}
      </Box>
    </>
  )
}
